import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, className = '', onClick }) => {
  const baseStyles = 'bg-[var(--v-surface-1)] rounded-[var(--v-radius-xl)] border border-[var(--v-border-light)] shadow-[var(--v-shadow-sm)] overflow-hidden';
  const interactiveStyles = onClick ? 'cursor-pointer hover:shadow-[var(--v-shadow-md)] hover:border-[var(--v-border-strong)] transition-all transform hover:-translate-y-0.5' : '';
  
  return (
    <div 
      className={`${baseStyles} ${interactiveStyles} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
};

export const CardHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <div className={`p-6 border-b border-[var(--v-border-light)] ${className}`}>{children}</div>;
};

export const CardTitle: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <h3 className={`text-xl font-bold text-[var(--v-text-primary)] tracking-tight ${className}`}>{children}</h3>;
};

export const CardContent: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <div className={`p-6 ${className}`}>{children}</div>;
};
